export enum BillPathsEnum {
  bills = '/bills',
}
